//#region Imports

import React from 'react';
import { Header, Image, Modal, Segment, Transition } from 'semantic-ui-react';
import { animationDuration, fadeAnimation } from '../../consts/system-const';
import Botao from '../Botao';
import styles from './styles.module.scss';

//#endregion

export default function ModalConfirmaCancelaItem({
    showModalItem,
    handlerCloseModalItem,
    handlerClickSim,
    tituloModal,
    mensagemErro,
    mensagem,
    loading,
    sucesso,
    error
}) {
    const classeModal = error ? styles.modalExcluirErro : styles.modalExcluir;

    return (
        <Transition.Group animation={fadeAnimation} duration={animationDuration}>
            {showModalItem && (
                <Modal
                    closeIcon
                    open={showModalItem}
                    centered
                    closeOnDimmerClick={false}
                    closeOnEscape={true}
                    onClose={handlerCloseModalItem}
                    className={classeModal}
                >
                    <Modal.Content>
                        <Segment basic padded={false} textAlign='center'>
                            <div>
                                {tituloModal && <Header className={styles.tituloModalExcluir}>{tituloModal}</Header>}
                                <Image
                                    src={require('../../assets/img/warning.png')}
                                    centered
                                    className={styles.imgErro}
                                />
                                {error ? (
                                    <div>
                                        <p>{mensagemErro}</p>
                                    </div>
                                ) : (
                                    <div className={styles.modalMensagem}>{mensagem}</div>
                                )}
                            </div>

                            <Botao
                                content={error || sucesso ? 'Voltar' : 'Não'}
                                className={styles.btnDisabled}
                                clique={handlerCloseModalItem}
                            ></Botao>
                            {error ? null : (
                                <Botao
                                    content={'Sim'}
                                    clique={handlerClickSim}
                                    disabled={Boolean(error || sucesso)}
                                    loading={loading}
                                ></Botao>
                            )}
                        </Segment>
                    </Modal.Content>
                </Modal>
            )}
        </Transition.Group>
    );
}
